<template>
  <div class="fin-stmt">
    <div v-if="overview.opening !== null" class="ui-sr fin-sr--static">
      <span class="fin-sr__label"><b>{{ $t("finance_opening_balance") }}</b></span>
      <span class="fin-num">{{ money(overview.opening) }}</span>
      <span></span>
    </div>

    <component
      :is="clickable ? 'button' : 'div'"
      v-for="row in overview.rows"
      :key="row.key"
      class="ui-sr"
      :class="{ 'is-click': clickable, 'is-on': activeKey === row.key }"
      :type="clickable ? 'button' : null"
      @click="clickable && $emit('line', row)"
    >
      <span class="fin-sr__label">
        <b>{{ translate(row.label) }}</b>
        <v-tooltip v-if="row.isCash" top max-width="320">
          <template #activator="{ on, attrs }">
            <v-icon x-small class="ml-1" v-bind="attrs" v-on="on" @click.stop>mdi-information-outline</v-icon>
          </template>
          <span>{{ $t("finance_cash_tooltip") }}</span>
        </v-tooltip>
        <span class="fin-bar-mini" aria-hidden="true"><i :class="row.value < 0 ? 'is-out' : 'is-in'" :style="{ width: `${barWidth(row)}%` }"></i></span>
      </span>
      <b class="fin-num" :class="row.value < 0 ? 'is-out' : 'is-in'">{{ money(row.value, true) }}</b>
      <v-icon v-if="clickable" size="16" class="fin-sr__chev">mdi-chevron-right</v-icon>
      <span v-else></span>
    </component>

    <div v-if="overview.closing !== null" class="ui-sr fin-sr--total">
      <span class="fin-sr__label">{{ $t("finance_closing_balance") }}</span>
      <span class="fin-num">{{ money(overview.closing) }}</span>
      <span></span>
    </div>
  </div>
</template>

<script>
import { formatMoney } from "@/components/restaurant/finance/constants";

/**
 * Razrada perioda: početno stanje, redovi (promet, provjzija, ...) i stanje na kraju. Isti prikaz je na Zaradi
 * (redovi se otvaraju u panelu) i u detalju obračuna. Traka ispod naziva pokazuje udio reda u najvećem redu.
 */
export default {
  name: "FinanceStatement",
  props: {
    /** rezultat parseOverview */
    overview: { type: Object, required: true },
    clickable: { type: Boolean, default: false },
    activeKey: { type: String, default: "" },
  },
  computed: {
    maxAbs() {
      return Math.max(1, ...this.overview.rows.map((row) => Math.abs(row.value)));
    },
  },
  methods: {
    money(value, signed) {
      return formatMoney(value, this.overview.currency, { signed });
    },
    barWidth(row) {
      return Math.round((Math.abs(row.value) / this.maxAbs) * 100);
    },
  },
};
</script>
